<script setup lang="ts">
defineProps<{
  color?: 'primary' | 'secondary' | 'tertiary' | 'exclusion'
  isAbbreviated?: boolean
}>()
</script>

<template>
  <div
    class="label whitespace-nowrap"
    :class="{
      abbreviated: isAbbreviated,
      'bg-[#E2E6ED] text-neutral-900': !color,
      'bg-[#48559C] text-white': color === 'primary',
      'text-primary-900 bg-[#D0D4EF]': color === 'tertiary',
      // TODO: Determine proper context for exclusion styling
      'text-exclusion-dark bg-exclusion': color === 'exclusion',
    }"
  >
    <slot />
  </div>
</template>

<style scoped>
.label {
  @apply inline-flex h-5 items-center justify-center rounded-full px-3 text-xs leading-none font-medium tracking-normal;
}
.label.abbreviated {
  border-radius: 50%;
  width: 1.25rem;
  padding: 0;
}
</style>
